var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.51 20.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-start") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.29,9.81,19.75.14a.62.62,0,0,0-1,.48V5.87a.62.62,0,0,1-.62.62H.61A.61.61,0,0,0,0,7.1v6.35a.62.62,0,0,0,.61.62H18.12a.61.61,0,0,1,.62.61v5.26a.62.62,0,0,0,1,.47l11.54-9.66A.62.62,0,0,0,31.29,9.81Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowStart);
export default __webpack_public_path__ + "static/media/arrow-start.82f7c52672d76d912406735be1c22f5d.svg";
export { ForwardRef as ReactComponent };